// TODO : 
// 1. Module Import Proxy JS of THREE Lib
// 2. planeCurve on 2 AXIS
// 3. Performance Optimization/Refactor for better frame rate
import TWEEN from "@tweenjs/tween.js"
import * as THREE from "three";
import { planeCurve, randomInt } from "./utils"

const getImageUrl = (path)=> {
  if (process.env.NODE_ENV === 'production') {
    // TODO : AWS Cloudfront + S3에 이미지 요청하여 canvas에 적용이 되게끔 찾아보고 적용하고.
    // return `https://plus-file.creators.ogq.me${path.replace('assets', '')}`
    return require(`@/${path}`)
  } else {
    return require(`@/${path}`)
  }
}

class StageScene {
  constructor(options) {
    this.scene = new THREE.Scene()
    this.width = options?.width || window.innerWidth
    this.height = options?.height || window.innerHeight
    const aspect = this.width / this.height
    // TODO : PerspectiveCamera를 멀리 배치 하고 zoom하는 방식 대신, 
    // 좀더 사용케이스에 맞는 Orthographic 카메라로 대체.
    this.camera = new THREE.PerspectiveCamera(20, aspect, 10, 20)
    this.camera.zoom = 2
    this.camera.updateProjectionMatrix()
    this.outer = new THREE.Group()
    this.pivot = new THREE.Group()
    this.doneInit = false
    this.lastTickTime = null
  }

  loadImages(count) {
    // 캔버스에 사용될 이미지가 다 로딩된걸 확인하고 모든걸 시작.
    return new Promise((res)=> {
      let loadedCount = 0
      for (let i=1; i <= count; i++) {
        const img = new Image()
        img.onload = ()=> {
          loadedCount += 1
          if (loadedCount >= count) {
            return res(true)
          }
        }
        img.src = getImageUrl(`assets/rot/stick${i}.webp`)
      }
    })
  }

  setStageDimensions({width, height}) {
    this.width = width || this.width
    this.height = height || this.height
    const aspect = this.width / this.height
    this.camera.aspect = aspect
    this.camera.updateProjectionMatrix()
    this.renderer.setSize(this.width, this.height)
  }

  async init(canvas, options) {
    const sides = 12
    
    await this.loadImages(sides)
    
    // THREEjs 랜도로를 캔버스 요소에 설정 및 연결
    this.renderer = new THREE.WebGLRenderer({ 
      canvas,
      antialias: true,
      alpha: true
    })

    this.renderer.setClearColor(0x000000, 0)
    this.renderer.setPixelRatio(window.devicePixelRatio)

    // 인트로 애니메이션 후크가 존재하면 연결
    this.onIntroComplete = options?.onIntroComplete || null 

    // 기본 설정값 
    this.camera.position.set(0, 3.25, 13)
    this.camera.lookAt(0,0,0)
    this.outer.position.y = 0.1
    this.outer.rotation.z = Math.PI * 20/360
    this.scene.add(this.camera)
    this.outer.add(this.pivot)
    this.scene.add(this.outer);
    
    // 반지름 월드 크기
    const radius = 1.9

    // 면 갯수에 따라 각 면의 위치 및 회전값을 구하고 적용함.
    for (let i=1; i <= sides; i++) {
      const degrees = 360/sides * i
      const radian = degrees * Math.PI/180
      const plane = new THREE.PlaneGeometry(1, 1, 20, 2)
      const imgUrl = getImageUrl(`assets/rot/stick${i}.webp`)
      const loader = new THREE.TextureLoader()
      const texture = loader.load(imgUrl)
      const material = new THREE.MeshBasicMaterial({
        color: 0xFFFFFF, transparent: true, side: THREE.DoubleSide, map: texture
      })
      planeCurve(plane, -0.07)
      const mesh = new THREE.Mesh(plane, material)
      mesh.position.x = radius * Math.cos(radian)
      mesh.position.z = radius * Math.sin(radian)
      mesh.rotation.y = (Math.PI / 2 - radian) + Math.PI
      this.pivot.add(mesh)
    }

    // 조명 설정
    const ambient = new THREE.AmbientLight(0x404040, 4)
    const point = new THREE.PointLight(0xE4FF00, 1, 10)
    point.position.set(3, 3, 2)
    this.scene.add(ambient)
    this.scene.add(point)
    this.setStageDimensions(options)
    this.doneInit = true
    this.intro()
    const tick = (t) => {
      // 매 틱마다 프레임을 새로 그려줌.
      
      // TWEEN 객체가 시간을 알 수 있게 넘겨줌. requestAnimationFramed에서 주는 시간은 최초 요청부터 지금까지의 지난 ms.
      TWEEN.update(t)

      // 렌더러에 렌더 요청한 후 다시 프레임을 요청함. 무한반복.
      this.renderer.render(this.scene, this.camera)
      window.requestAnimationFrame(tick)
    }
    tick()
    if (options?.onAfterInit) options.onAfterInit()
  }

  intro() {
    // 인트로를 시작하기 전에, 나름 맞춰둔 계산식을 실행하여, 3D 객체가 화면에 잘 맞게 설정해줌.
    this.fitToStage()

    // 인트로 회전 시간
    const introRotationTime = 2400
    // 인트로 멀리서 오는 시간
    const planeMoveTime = 2400

    // pivot GROUP에 있는 메쉬를 루프돌림
    for (let i=0; i < this.pivot.children.length; i++) {
      const mesh = this.pivot.children[i]
      const center = new THREE.Vector3()
      const meshPos = mesh.position
      // 방향 좌표 구함 (좌표 A - B).normalize() = 방향좌표
      const dirV = new THREE.Vector3().subVectors(meshPos, center).normalize()
      const dist = randomInt(15, 25)
      const startAtPos = new THREE.Vector3().copy(meshPos)
        .add(
          // 좌표 + (방향좌표 * 거리) = 좌표에서 방향좌표로 N만큼의 거리 (모든 3D 계산법에 적용되는 공식)
          new THREE.Vector3().copy(dirV).multiply(new THREE.Vector3(dist, dist, 0))
        );
      // TWEEN.js로 시작 위치에서 최종위치까지 틱당 값을 받아 메쉬에 적용
      const tween = new TWEEN.Tween(startAtPos)
        .to({...mesh.position}, planeMoveTime)
        .onUpdate((coords)=> {
          mesh.position.x = coords.x
          mesh.position.y = coords.y
          mesh.position.z = coords.z
        })
      tween.start()
    }
    // 반복 회전 트윈
    const continuousRotTween = new TWEEN.Tween({y: 0})
      .to({y: 360}, 15000)
      .onUpdate((rotation)=> {
        this.pivot.rotation.y = rotation.y * -Math.PI/180
      }).repeat(Infinity)
    // 인트로 회전 트윈
    const introRotTween = new TWEEN.Tween({y: 0, x: 75})
      .to({y: 360 * 1, x: 0}, introRotationTime)
      .onUpdate((rotation)=> {
        this.pivot.rotation.y = rotation.y * -Math.PI/180
        this.pivot.rotation.x = rotation.x * -Math.PI/180
      })
      .onComplete(()=> {
        if (this.onIntroComplete) this.onIntroComplete()
      })
      .easing(TWEEN.Easing.Cubic.In)
      .chain(continuousRotTween) // 인트로 후 바로 반복 회전 트윈 연결
    introRotTween.start()
  }

  onResize(options = {}) {
    // 윈도우 리사이즈 함수
    if (!this.doneInit) return
    this.setStageDimensions(options)
    this.fitToStage()
  }

  fitToStage() {
    // 조정된 컨테이너 크기에 따라 줌 값 새로 구하고 적용.
    // TODO : 수동 구간 대신 카메라 좌표 및 피사체의 거리를 이용한 계산식.
    if (!this.doneInit) return
    const max = 940
    const min = 380
    const current = Math.max(Math.min(this.width, max), min) - min
    const percentage = current / (max - min)
    const maxWorld = 2
    let minWorld = 1.2
    if (this.width <= 420) {
      minWorld = 1.1
    }
    const newWorld = Math.max(Math.min(percentage * maxWorld, 2), minWorld)
    this.camera.zoom = newWorld
    this.camera.updateProjectionMatrix()
    return newWorld
  }
}

export default StageScene